import styled, { keyframes } from 'styled-components';

// ─── Page shell ─────────────────────────────────────────────────────────────
export const PageWrap = styled.div`
  background: linear-gradient(160deg, rgba(8,8,8,.98) 0%, rgba(12,18,32,.97) 50%, rgba(8,8,8,.98) 100%);
  background-color: #080b12;
  min-height: 100vh;
  margin-top: -72px;
  padding-top: 72px;
  @media (max-width: 768px) { margin-top: -60px; padding-top: 60px; }
`;

export const Inner = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 1.45rem 1.1rem 3.7rem;
`;

// ─── Header bar ─────────────────────────────────────────────────────────────
export const PropsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.1rem;
  border: 1px solid rgba(148,163,184,0.22);
  background:
    linear-gradient(130deg, rgba(10,22,40,0.92) 0%, rgba(12,18,32,0.86) 45%, rgba(30,19,5,0.76) 100%);
  border-radius: 18px;
  margin-bottom: 0.95rem;
  box-shadow: 0 16px 42px -30px rgba(2,6,23,0.9);
`;

// ─── Prop type tabs bar ───────────────────────────────────────────────────────────
export const PropTypeTabs = styled.div`
  display: flex;
  gap: 0;
  overflow-x: auto;
  border: 1px solid rgba(148,163,184,0.2);
  border-radius: 12px;
  background: rgba(15,23,42,0.5);
  margin-bottom: 1rem;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar { display: none; }

  @media (max-width: 680px) { display: none; }
`;

export const PropTypeTab = styled.button`
  flex-shrink: 0;
  padding: 0.72rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: ${({ $active }) => $active ? 'linear-gradient(120deg, rgba(245,158,11,0.2), rgba(251,191,36,0.1))' : 'transparent'};
  color: ${({ $active }) => $active ? '#fcd88f' : '#64748b'};
  border: none;
  border-right: 1px solid rgba(148,163,184,0.14);
  cursor: pointer;
  transition: color 0.18s, background 0.18s;
  white-space: nowrap;

  &:hover:not(:disabled) { color: #e2e8f0; }

  &:last-child {
    border-right: none;
  }
`;

export const MobileTabSelect = styled.select`
  display: none;
  width: 100%;
  padding: 0.72rem 0.9rem;
  border-radius: 10px;
  border: 1px solid rgba(148,163,184,0.28);
  background: rgba(15,23,42,0.8);
  color: #f0c876;
  font-size: 0.88rem;
  font-weight: 700;
  outline: none;
  margin-bottom: 1.1rem;
  cursor: pointer;

  option { background: #0f172a; color: #f8fafc; }

  @media (max-width: 680px) { display: block; }
`;

// ─── Game group ──────────────────────────────────────────────────────────────
export const GameGroupWrap = styled.div`
  margin-bottom: 1.6rem;
  border: 1px solid rgba(148,163,184,0.2);
  border-radius: 18px;
  overflow: hidden;
  background: rgba(10,15,28,0.66);
  box-shadow: 0 20px 46px -34px rgba(2,6,23,0.85);
`;

export const GameGroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1.05rem;
  background:
    linear-gradient(90deg, rgba(15,23,42,0.82) 0%, rgba(15,23,42,0.55) 100%);
  border-bottom: 1px solid rgba(148,163,184,0.18);
  flex-wrap: wrap;
`;

export const GameMatchup = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 0.92rem;
  font-weight: 800;
  color: #f8fafc;
  letter-spacing: -0.01em;
`;

export const GameTime = styled.span`
  font-size: 0.7rem;
  color: #94a3b8;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const TeamLogoCircle = styled.div`
  width: ${({ $size }) => $size || '30px'};
  height: ${({ $size }) => $size || '30px'};
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px ${({ $color }) => $color || 'rgba(255,255,255,0.25)'},
              0 2px 8px rgba(0,0,0,0.4);
  overflow: hidden;

  img {
    width: 72%;
    height: 72%;
    object-fit: contain;
    display: block;
  }
`;

export const GameBody = styled.div`
  padding: 0.85rem 1rem;
  display: grid;
  gap: 1rem;
`;

// ─── Team group within a prop type ─────────────────────────────────────────────
export const TeamGroupWrap = styled.div`
  margin-bottom: 1.5rem;
`;

export const TeamGroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.45rem 0.05rem 0.55rem;
  margin-bottom: 0.72rem;
  border-bottom: 1px solid rgba(148,163,184,0.16);
`;

export const TeamGroupName = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  font-weight: 800;
  color: #f1f5f9;
  letter-spacing: -0.01em;
`;

export const PositionBadge = styled.span`
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8cd5ff;
  background: rgba(14,165,233,0.14);
  border: 1px solid rgba(56,189,248,0.36);
  border-radius: 999px;
  padding: 2px 8px;
  margin-left: auto;
  flex-shrink: 0;
`;

export const TeamGroupCount = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  color: #bae6fd;
  background: rgba(14,165,233,0.14);
  border: 1px solid rgba(56,189,248,0.34);
  border-radius: 999px;
  padding: 2px 9px;
`;

export const TeamGroupGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.7rem;
`;

export const PropsTitle = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: clamp(1.3rem, 3vw, 1.85rem);
  font-weight: 800;
  color: #f8fafc;
  margin: 0;
  letter-spacing: -0.02em;
`;

export const PropsEyebrow = styled.p`
  color: #94a3b8;
  font-size: 0.88rem;
  margin: 0.2rem 0 0;
`;

export const SportTabs = styled.div`
  display: flex;
  gap: 0.45rem;
  flex-wrap: wrap;
`;

export const SportTab = styled.button`
  border: 1px solid ${({ $active }) =>
    $active ? 'rgba(196,152,14,0.7)' : 'rgba(148,163,184,0.22)'};
  background: ${({ $active }) =>
    $active ? 'rgba(196,152,14,0.14)' : 'rgba(255,255,255,0.04)'};
  color: ${({ $active }) =>
    $active ? '#f0c876' : '#94a3b8'};
  border-radius: 999px;
  padding: 0.38rem 0.9rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 1;
  transition: border-color 0.18s, background 0.18s, color 0.18s;

  &:hover:not(:disabled) {
    border-color: rgba(196,152,14,0.55);
    color: #f0c876;
  }
`;

// ─── Search / filter bar ────────────────────────────────────────────────────
export const FilterRow = styled.div`
  display: flex;
  gap: 0.65rem;
  align-items: center;
  margin-bottom: 1.05rem;
  flex-wrap: wrap;
  padding: 0.7rem 0.8rem;
  border-radius: 14px;
  border: 1px solid rgba(148,163,184,0.18);
  background: rgba(15,23,42,0.52);
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 160px;
  max-width: 340px;
  padding: 0.64rem 0.88rem;
  border-radius: 11px;
  border: 1px solid rgba(148,163,184,0.24);
  background: rgba(2,6,23,0.55);
  color: #f8fafc;
  font-size: 0.9rem;
  outline: none;
  transition: border-color 0.2s, background 0.2s;

  &::placeholder { color: #64748b; }

  &:focus {
    border-color: rgba(56,189,248,0.56);
    background: rgba(2,6,23,0.74);
  }
`;

export const ResultCount = styled.span`
  color: #cbd5e1;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: rgba(245,158,11,0.14);
  border: 1px solid rgba(245,158,11,0.38);
  border-radius: 999px;
  padding: 0.26rem 0.64rem;
  margin-left: auto;
`;

// ─── Prop type group ─────────────────────────────────────────────────────────
// ─── Props grid ──────────────────────────────────────────────────────────────
// ─── Prop card ───────────────────────────────────────────────────────────────
export const PropCard = styled.button`
  background:
    radial-gradient(circle at 0% 0%, rgba(56,189,248,0.16) 0%, rgba(56,189,248,0) 44%),
    radial-gradient(circle at 100% 100%, rgba(245,158,11,0.12) 0%, rgba(245,158,11,0) 46%),
    rgba(15,23,42,0.88);
  border: 1px solid rgba(148,163,184,0.24);
  border-radius: 15px;
  padding: 0.9rem 0.95rem;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.2s, background 0.2s, box-shadow 0.2s;
  width: 100%;

  &:hover {
    border-color: rgba(56,189,248,0.56);
    background:
      radial-gradient(circle at 0% 0%, rgba(56,189,248,0.2) 0%, rgba(56,189,248,0) 52%),
      radial-gradient(circle at 100% 100%, rgba(245,158,11,0.16) 0%, rgba(245,158,11,0) 52%),
      rgba(15,23,42,0.96);
    transform: translateY(-2px);
    box-shadow: 0 16px 32px -26px rgba(14,165,233,0.55);
  }
`;

export const PropCardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.55rem;
`;

export const PropPlayerName = styled.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  font-size: 0.98rem;
  color: #f8fafc;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PropTeamBadge = styled.span`
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #dbeafe;
  background: rgba(59,130,246,0.18);
  border: 1px solid rgba(96,165,250,0.35);
  border-radius: 999px;
  padding: 2px 8px;
  flex-shrink: 0;
`;

export const PropLineRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  margin-bottom: 0.25rem;
`;

export const PropTypeName = styled.span`
  font-size: 0.74rem;
  color: #94a3b8;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const PropLineValue = styled.span`
  font-size: 1rem;
  font-weight: 800;
  color: #fde68a;
  font-family: 'Poppins', sans-serif;
`;

export const PropCardFooter = styled.div`
  display: flex;
  gap: 0.45rem;
  margin-top: 0.62rem;
  flex-wrap: wrap;
`;

export const PropStatPill = styled.span`
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #e2e8f0;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.16);
  border-radius: 999px;
  padding: 3px 8px;
`;

export const ViewHistoryChip = styled.span`
  margin-left: auto;
  font-size: 0.67rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #7dd3fc;
  display: flex;
  align-items: center;
  gap: 4px;
`;

// ─── Empty / error / loading states ─────────────────────────────────────────
export const StateWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4.5rem 1rem;
  color: #475569;
  text-align: center;
  gap: 0.75rem;

  i { font-size: 2.6rem; color: #334155; }
  h4 { font-family: 'Poppins', sans-serif; color: #e2e8f0; margin: 0; }
  p  { margin: 0; font-size: 0.9rem; max-width: 420px; line-height: 1.6; }
`;

// ─── Player detail modal ─────────────────────────────────────────────────────
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(2,6,23,0.82);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 3.5rem 1rem 1.5rem;
  overflow-y: auto;
`;

export const ModalSheet = styled.div`
  background:
    radial-gradient(circle at 100% 0%, rgba(56,189,248,0.16) 0%, rgba(56,189,248,0) 48%),
    linear-gradient(160deg, #0c1526 0%, #0f172a 100%);
  border: 1px solid rgba(148,163,184,0.28);
  border-radius: 22px;
  width: 100%;
  max-width: 720px;
  padding: 1.5rem;
  position: relative;
  box-shadow: 0 28px 60px -28px rgba(2,6,23,0.95);
`;

export const ModalClose = styled.button`
  position: absolute;
  top: 1.1rem;
  right: 1.1rem;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 50%;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover { background: rgba(56,189,248,0.2); color: #f8fafc; }
`;

export const ModalPlayerName = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-weight: 800;
  color: #f8fafc;
  margin: 0 2.5rem 0.25rem 0;
  font-size: clamp(1.1rem, 3vw, 1.5rem);
`;

export const ModalMeta = styled.div`
  display: flex;
  gap: 0.55rem;
  flex-wrap: wrap;
  margin-bottom: 1.2rem;
`;

export const MetaChip = styled.span`
  font-size: 0.74rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${({ $accent }) => $accent ? '#f0c876' : '#94a3b8'};
  background: ${({ $accent }) => $accent ? 'rgba(196,152,14,0.14)' : 'rgba(255,255,255,0.06)'};
  border: 1px solid ${({ $accent }) => $accent ? 'rgba(196,152,14,0.4)' : 'rgba(255,255,255,0.1)'};
  border-radius: 6px;
  padding: 2px 8px;
`;

export const PropTabs = styled.div`
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid rgba(148,163,184,0.18);
`;

export const PropTab = styled.button`
  border: 1px solid ${({ $active }) => $active ? 'rgba(56,189,248,0.65)' : 'rgba(148,163,184,0.2)'};
  background: ${({ $active }) => $active ? 'rgba(14,165,233,0.18)' : 'transparent'};
  color: ${({ $active }) => $active ? '#7dd3fc' : '#64748b'};
  border-radius: 999px;
  padding: 0.32rem 0.8rem;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.18s;
`;

export const HistoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.86rem;

  thead tr {
    border-bottom: 1px solid rgba(148,163,184,0.22);
  }

  thead th {
    padding: 0.42rem 0.6rem;
    text-align: left;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #64748b;
  }

  tbody tr {
    border-bottom: 1px solid rgba(148,163,184,0.11);
    transition: background 0.14s;
    &:hover { background: rgba(56,189,248,0.06); }
  }

  tbody td {
    padding: 0.5rem 0.6rem;
    color: #e2e8f0;
    vertical-align: middle;
  }
`;

export const HitBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 9px;
  border-radius: 999px;
  background: ${({ $hit }) =>
    $hit === true ? 'rgba(22,163,74,0.2)' :
    $hit === false ? 'rgba(220,38,38,0.2)' :
    'rgba(255,255,255,0.06)'};
  color: ${({ $hit }) =>
    $hit === true ? '#4ade80' :
    $hit === false ? '#f87171' :
    '#94a3b8'};
  border: 1px solid ${({ $hit }) =>
    $hit === true ? 'rgba(74,222,128,0.35)' :
    $hit === false ? 'rgba(248,113,113,0.35)' :
    'rgba(255,255,255,0.1)'};
`;

export const StatSummaryRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.5rem;
  margin-bottom: 1rem;

  @media (max-width: 520px) { grid-template-columns: repeat(3, 1fr); }
`;

export const StatBox = styled.div`
  background:
    radial-gradient(circle at 100% 0%, rgba(56,189,248,0.15) 0%, rgba(56,189,248,0) 52%),
    rgba(15,23,42,0.62);
  border: 1px solid rgba(148,163,184,0.18);
  border-radius: 12px;
  padding: 0.75rem 0.85rem;

  .label { font-size: 0.7rem; color: #64748b; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; }
  .value { font-size: 1.2rem; font-weight: 800; color: #f8fafc; font-family: 'Poppins', sans-serif; margin-top: 0.15rem; }
`;

const shimmer = keyframes`
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export const SkeletonBlock = styled.div`
  height: ${({ $h }) => $h || '4.5rem'};
  border-radius: 14px;
  background: linear-gradient(90deg, rgba(30,41,59,0.8) 0%, rgba(51,65,85,0.6) 45%, rgba(30,41,59,0.8) 100%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.15s ease-in-out infinite;
`;
